import axios from 'axios';

const getCentroCustos = params => axios.get('/centro-custos', { params });

export default {
  getCentroCustos,
};
